__turbopack_context__.v({
  "column": "UuNlaa_column",
  "width-1_2": "UuNlaa_width-1_2",
  "width-1_3": "UuNlaa_width-1_3",
  "width-1_4": "UuNlaa_width-1_4",
  "width-1_5": "UuNlaa_width-1_5",
  "width-2_3": "UuNlaa_width-2_3",
  "width-2_5": "UuNlaa_width-2_5",
  "width-3_4": "UuNlaa_width-3_4",
  "width-3_5": "UuNlaa_width-3_5",
  "width-4_5": "UuNlaa_width-4_5",
});
